import Header from "../../components/Header"
import { NavLink } from "react-router-dom"


const NavigationItem: React.FC<{ to?: string, title: string }> = ({ to = "/", title }) => {
    return <NavLink end className={({ isActive }) => `rounded-t-lg ${isActive ? "text-zinc-700 bg-white" : "bg-transparent text-white"} px-5 py-2`} to={to}>{title}</NavLink>
}
const AdminNavigation = () => {
    return (
        <div className="px-5 md:px-32 flex items-center gap-5 bg-[#46464c] overflow-x-auto">
            <NavigationItem to={`/admins/leagues`} title="Ligas" />
            <NavigationItem to={`/admins/seasons`} title="Temporadas" />
            <NavigationItem to={`/admins/league-dates`} title="Fechas" />
            <NavigationItem to={`/admins/matches`} title="Partidos" />
        </div>
    )
}


const AdminsPage = () => {
    return (
        <div className="flex flex-col">
            <Header className="bg-[#46464c]">
                <p className="text-white font-extrabold uppercase text-4xl">Admins</p>
                <p className="text-white">Sí no entendés algo de esta página, evitá interactuar.</p>
            </Header>
            <AdminNavigation />
        </div>
    )
}


export default AdminsPage